import { 
    Route,
    Routes,
} from "react-router-dom";
import React from "react";
import { Users } from "../views/Users";
import { Ot } from "../views/Ot";
import OtTabsSeguimiento from "../views/OtTabsSeguimiento";
import CrearOt from "../views/ots/CrearOt";
import { Magnitud } from "../views/Magnitud";
import { Items } from "../views/Items";
import { Otselect } from "../views/Otselect";
import { Ingresos } from "../views/Ingresos";
import { SeguimientoControler } from "../components/Seguimiento/Seguimiento_controler";
import { ViewIngreso } from "../components/Ingresos/ViewIngreso";
import { Profile } from "../components/Profile/Profile";
import ListEquipments from "../components/Equipo/ListEquipments";
import ProfileEquipments from "../components/Equipo/ProfileEquipments";
import { Settinglistingreso } from "../components/Ingresos/Settinglistingreso";
import { Rolescreate } from "../views/Rolescreate";
import { Clientes} from '../views/Clientes';
import { Cotizacion } from "../components/Cotizacion/Cotizacion";
import { Calendario } from "../views/Calendario";
import { Dashboard } from "../components/dashboard/Dashboard";
import Information from "../views/Information";
import TracingEquipment from "../components/Equipo/TracingEquipment";
import { OtsonClient } from "../components/VisitasClient/OtsonClient";
import EqInOtList from "../components/EqInOt/EqInOtList";
import { ActasList } from "../components/Pdfs/ActasList";
import { ActualizarDate } from "../components/Ingresos/ActualizaDate";
import SheetsWork from "../components/Soportes/SheetsWork";
import EqPatrones from "../components/EqPatron/EqPatrones";
import { Areas } from "../components/Areas/AreasRoles";
import { SettingNot } from "../components/SettingNot/SettingNot";
import { ConsulActividades } from "../components/EqPatron/ConsulActividades";
import PerfilPatron from "../components/EqPatron/PerfilPatron";
import ListProgramaciones from "../components/Programaciones/ListProgramaciones";
import { OtSelectTwo } from "../views/OtSelectTwo";
import OtSelectMain  from "../components/OtSelect/OtSelectMain.js";
import PerfilPersonal from "../components/users/PerfilUsuario.js";
import Registros from "../components/Registros/Registros.jsx";
// Componentes legacy de viaticos removidos (modulo reemplazado por Bolsa de Fondos):
// import ListaEgresosViaticos from "../components/Viaticos/ListaEgresosViaticos.jsx"
// import ReporteViaticos from "../components/Viaticos/ReporteViaticos.jsx";
// Módulo Financiero (011)
import MiBolsa from "../components/Finanzas/MiBolsa.jsx";
import MiHistorialBolsillo from "../components/Finanzas/MiHistorialBolsillo.jsx";
import InformeFinanciero from "../components/Finanzas/InformeFinanciero.jsx";
import RevisionCierre from "../components/Finanzas/RevisionCierre.jsx";
import MisRelacionesGastos from "../components/Finanzas/MisRelacionesGastos.jsx";
import RevisionRelaciones from "../components/Finanzas/RevisionRelaciones.jsx";
import RevisionRelacionDetalle from "../components/Finanzas/RevisionRelacionDetalle.jsx";
import ErroresSincronizacion from "../components/Finanzas/ErroresSincronizacion.jsx";
import GestionBolsillos from "../components/Finanzas/GestionBolsillos.jsx";
import GestionEntregas from "../components/Finanzas/GestionEntregas.jsx";
import ConfiguracionContable2 from "../components/Finanzas/ConfiguracionContable.jsx";
import DashboardFinanciero from "../components/Finanzas/DashboardFinanciero.jsx";
import ComprobantesContables from "../components/Finanzas/ComprobantesContables.jsx";
import DetalleRelacion from "../components/Finanzas/DetalleRelacion.jsx";
import ListadoPropuestas from "../components/Propuestas/ListadoPropuestas.js";
import CrearPropuesta from "../components/Propuestas/CrearPropuesta.js";
import DetallePropuesta from "../components/Propuestas/DetallePropuesta.js";
import ConfigPlantillaPropuesta from "../components/Propuestas/ConfigPlantillaPropuesta.js";
import DashboardPropuestas from "../components/Propuestas/DashboardPropuestas.js";
import ListaSolicitudes from "../components/Solicitudes/ListaSolicitudes.jsx";
import PatronEstadoView from "../components/EqPatron/ConsultaEstadoPublico.js";
// Componentes legacy CajaMenor / MiRelacionViaticos removidos:
// import AdministrarCajasMenores from "../components/CajaMenor/AdministrarCajasMenores.jsx";
// import MiCajaMenor from "../components/CajaMenor/Micajamenor.jsx";
// import MiRelacionViaticos from "../components/Viaticos/MiRelacionViaticos.jsx";
// import ConfirmarRecepcionCaja from "../components/CajaMenor/ConfirmarRecepcionCaja.jsx";
import SyncSiigoSuppliers from "../components/ConexionContables/SyncSiigoSuppliers.jsx";
import ListarPrestamos from "../components/Prestamos/ListarPrestamos.jsx";
import CrearPrestamo from "../components/Prestamos/CrearPrestamos.jsx";
import DetallePrestamos from "../components/Prestamos/DetallePrestamo.jsx";
import EditarPrestamo from "../components/Prestamos/EditarPrestamo.jsx";
import CuentasContables from "../components/ConexionContables/CuentasContables.jsx";
import SalidaEntrada from "../components/SalidaEntradaPatrones/SalidaEntrada.jsx";
import { PlantillasList, PlantillaCard } from "../components/mediciones";
import LotesList from "../components/mediciones/lotes/LotesList";
import LoteDetail from "../components/mediciones/lotes/LoteDetail";
import RegistroMediciones from "../components/mediciones/loteMediciones/RegistroMediciones";
import RequisicionesPage from "../pages/requisiciones/RequisicionesPage";
import RequisicionFormPage from "../pages/requisiciones/RequisicionFormPage";
import RequisicionDetailPage from "../pages/requisiciones/RequisicionDetailPage";
import ProveedoresPage from "../pages/proveedores/ProveedoresPage";
import ConfiguracionContable from "../views/contabilidad/ConfiguracionContable";
import RequisicionPublicaPage from "../pages/requisiciones/RequisicionPublicaPage.js";
import { ListadoImpuestos } from "../components/Impuestos/ListadoImpuestos.jsx";
import RecibirEquiposPrestamos from "../components/Prestamos/RecibirEquiposPrestamos.jsx";
import ConfirmarEntregaPublico from "../components/Prestamos/ConfirmarEntregaPublico";


const ContentRouter = () =>{
    return(
        <Routes>
            <Route exact path="/Ot/:id" element={<Otselect/>} /> 
            <Route exact path="/Programacion/:id" element={<OtSelectMain/>} /> 
            <Route exact path="/Visitas" element={<OtsonClient/>} /> 
            <Route exact path="/Seguimiento/:id" element={<SeguimientoControler/>} /> 
            <Route exact path="/users" element={<Users />} /> 
            {/* /Otlista/total abre los 4 tabs: OT original + seguimiento por estado.
                Otros IDs van directo al componente clásico de Ot. */}
            <Route exact path="/Otlista/total" element={<OtTabsSeguimiento />} />
            <Route exact path="/Otlista/:id" element={<Ot />} />
            <Route exact path="/Cotizacion" element={<Cotizacion/>} />
            <Route exact path="/crearot" element={<CrearOt/>} />
            <Route exact path="/magnitud" element={<Magnitud/>} />
            <Route exact path="/mediciones/plantillas" element={<PlantillasList/>} />
            <Route exact path="/mediciones/plantillas/:id" element={<PlantillaCard/>} />
            <Route exact path="/mediciones/lotes" element={<LotesList/>} />
            <Route exact path="/mediciones/lotes/:id" element={<LoteDetail/>} />
            <Route exact path="/mediciones/lotes/:id/registrar" element={<RegistroMediciones/>} />
            <Route exact path="/items" element={<Items/>} />
            <Route exact path="/Ingresos/crear" element={<Ingresos/>} />
            <Route exact path="/Ingresos/listar" element={<Settinglistingreso/>} />
            <Route exact path="/Ingresos/:id" element={<ViewIngreso/>} />
            <Route exact path="/Ingresos" element={<Ingresos/>} />
            <Route exact path="/perfil" element={<Profile/>} />
            <Route exact path="/equipos" element={<ListEquipments />} />
            <Route exact path="/Roles" element={<Rolescreate />} />
            <Route exact path="/perfilEq" element={<ProfileEquipments />} />
            <Route exact path="/clientes" element={<Clientes />} />
            <Route exact path="/calendario" element={<Calendario />} />
            <Route path="/info" element={<Information/>} />
            <Route path="/seguimientoEquipo/:id" element={<TracingEquipment/>} />
            <Route exact path="/" element={<Dashboard />} />
            <Route exact path="*" element={<Dashboard />} />
            <Route exact path="/Actas" element={<ActasList />} />
            <Route exact path="/Ingresos/Actualizar" element={<ActualizarDate />} />
            <Route exact path="/eqInOt" element={<EqInOtList/>} />
            <Route exact path="/SheetWork" element={<SheetsWork/>} />
            <Route exact path="/Inventario" element={<EqPatrones/>} />
            <Route exact path="/Areas" element={<Areas/>} />
            <Route exact path="/Setting" element={<SettingNot/>} />
            <Route exact path="/PerfilPatron/:id" element={<PerfilPatron/>} />
            <Route exact path="/Actividades" element={<ConsulActividades/>} />
            <Route exact path="/ListaProgramaciones" element={<ListProgramaciones/>} />
            <Route exact path="/PerfilPersonal" element={<PerfilPersonal/>} />
            <Route exact path="/Registros" element={<Registros/>} />
            <Route exact path="/Solicitudes" element={<ListaSolicitudes/>} />
            {/* Rutas legacy /ListaEgreso y /ReporteViaticos removidas (modulo viaticos viejo). */}
            <Route exact path="/Prestamos" element={<ListarPrestamos/>} />
            <Route exact path="/prestamos/crear" element={<CrearPrestamo/>} />
            <Route exact path="/prestamos/detalle/:id" element={<DetallePrestamos/>} />
            <Route exact path="/prestamos/editar/:id" element={<EditarPrestamo/>} />
            <Route exact path="/prestamos/recibir/:id" element={<RecibirEquiposPrestamos/>} />
            <Route path="/propuestas" element={<ListadoPropuestas />} />
            <Route path="/propuestas/crear" element={<CrearPropuesta />} />
            <Route path="/propuestas/editar/:id" element={<CrearPropuesta />} />
            <Route path="/propuestas/ver/:id" element={<DetallePropuesta />} />
            <Route path="/propuestas/plantilla" element={<ConfigPlantillaPropuesta />} />
            <Route path="/propuestas/dashboard" element={<DashboardPropuestas />} />
            {/* Rutas legacy CajaMenor y MiRelacionViaticos removidas. */}
            {/* Módulo Financiero 011 */}
            <Route path="/MiBolsa" element={<MiBolsa />} />
            <Route path="/MiBolsa/historial" element={<MiHistorialBolsillo />} />
            <Route path="/Finanzas/informe" element={<InformeFinanciero />} />
            <Route path="/RevisionCierre/:id" element={<RevisionCierre />} />
            <Route path="/MisRelaciones" element={<MisRelacionesGastos />} />
            <Route path="/DetalleRelacion/:id" element={<DetalleRelacion />} />
            <Route path="/RevisionRelaciones" element={<RevisionRelaciones />} />
            <Route path="/RevisionRelaciones/:id" element={<RevisionRelacionDetalle />} />
            <Route path="/ErroresSincronizacion" element={<ErroresSincronizacion />} />
            <Route path="/GestionBolsillos" element={<GestionBolsillos />} />
            <Route path="/GestionEntregas" element={<GestionEntregas />} />
            <Route path="/ConfiguracionContable" element={<ConfiguracionContable2 />} />
            <Route path="/DashboardFinanciero" element={<DashboardFinanciero />} />
            <Route path="/ComprobantesContables" element={<ComprobantesContables />} />
            <Route exact path="/P/:inventario" element={<PatronEstadoView />} />
            <Route exact path="/Siigo/ActualizarTerceros" element={<SyncSiigoSuppliers />} />
            <Route exact path="/ConexionContable/CC" element={<CuentasContables />} />
            <Route exact path="/SalidaEntradaPatrones" element={<SalidaEntrada/>} />
            <Route exact path="/requisiciones" element={<RequisicionesPage />} />
            <Route exact path="/requisiciones/nueva" element={<RequisicionFormPage />} />
            <Route exact path="/requisiciones/editar/:id" element={<RequisicionFormPage />} />
            <Route path="/requisiciones/publica/:token" element={<RequisicionPublicaPage />} />
            <Route exact path="/requisiciones/:id" element={<RequisicionDetailPage />} />
            <Route exact path="/proveedores" element={<ProveedoresPage />} />
            <Route exact path="/contabilidad/configuracion" element={<ConfiguracionContable />} />
            <Route exact path="/contabilidad/taxes" element={<ListadoImpuestos />} />
            <Route exact path="/prestamos/entrega/:token" element={<ConfirmarEntregaPublico />} />
        </Routes>
        );
    }

export default ContentRouter;